// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.profile.RentalManagerUserProfileWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ProfileType,
  PropertyCountRangeType,
  UserProfileGetNamesRequestWebDto,
  UserProfileGetNamesResponseWebDto,
} from '../..';

interface SaveUserInfoParams {
  firstName?: string;
  /**
   * @deprecated
   */
  isLandlord?: boolean;
  /**
   * @deprecated
   */
  isPropertyManager?: boolean;
  lastName?: string;
  profileType?: ProfileType;
  /**
   * @deprecated
   */
  propertyCount?: number;
  propertyCountRangeType?: PropertyCountRangeType;
}
interface SetNameParams {
  firstName: string;
  lastName: string;
}

export const RentalManagerUserProfileWebApiHandler_getNames_Path = '/api/web/v1/users/profile/getNames';

/**
 * Get Zillow user profile names
 */
export const RentalManagerUserProfileWebApiHandler_getNames = (
  postData: UserProfileGetNamesRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserProfileGetNamesRequestWebDto, UserProfileGetNamesResponseWebDto>(
    {
      endpoint: RentalManagerUserProfileWebApiHandler_getNames_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserProfileWebApiHandler_saveUserInfo_Path = '/api/web/v1/users/profile/saveUserInfo';

/**
 * Set user info
 * @deprecated
 */
export const RentalManagerUserProfileWebApiHandler_saveUserInfo = (
  getParams: SaveUserInfoParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SaveUserInfoParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserProfileWebApiHandler_saveUserInfo_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserProfileWebApiHandler_setName_Path = '/api/web/v1/users/profile/setName';

/**
 * Set user's name
 * @deprecated
 */
export const RentalManagerUserProfileWebApiHandler_setName = (getParams: SetNameParams, client = getClient()) => {
  return httpFrontEndRequest<SetNameParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserProfileWebApiHandler_setName_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
